// Module
var code = "<div class=\"alert alert-warning text-center\" ng-if=\"(homeBlogpost != null) && (homeBlogpost != '') && (homeBlogpost != undefined)\"> <span ng-bind-html=\"homeBlogpost\"></span> </div> ";
// Exports
var _module_exports = code;;
var path = '/home/news.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;